<template>
    <div class="animated fadeIn">
        <b-row class="mb-2">
            <b-col>
                <b-button @click="add" class="btn btn-light pull-right">{{Core.Definition.getDefinition('Nouvelle entrée')}}</b-button>
            </b-col>
        </b-row>
        <ModalInstanceSelector
                ref="modalInstanceSelector"
                :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun modèle à afficher. Vous devriez créer un nouveau gabarit de formulaire.'),
                                borderVariant: 'white',
                                noBody: true
                }"
                :columns="[
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                }
                ]"
                :searchArgs="[
                            {
                                key: 'instance',
                                value: Mantle.FormTemplate.instanceForm
                            }
                ]"
                root="/form-template/list"
                @onAdd="onAdd"
                v-model="dataTemplates"
                :multiple="false">
        </ModalInstanceSelector>
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des entrées"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/form/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/form"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'entrée')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette entrée?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalInstanceSelector from '../../components/ModalInstanceSelector'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'FormList',
        components: {
            DynamicCardList,
            ModalTrash,
            ModalInstanceSelector
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataTemplates: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        type: 'date',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Utilisateur'),
                        key: 'userId',
                        type:'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Gabarit'),
                        key: 'formTemplateId',
                        type: 'select',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'formTemplateId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userId'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'formTemplateId',
                            type: 'select',
                            label: Core.Definition.getDefinition('Modèle'),
                            value: null,
                            onSelect: function() {}
                        },
                        {
                            id: 'userId',
                            type: 'select',
                            label: Core.Definition.getDefinition('Utilisateur'),
                            value: null,
                            onSelect: function() {}
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            add() {
                this.$refs.modalInstanceSelector.open = true
            },
            onAdd(row) {
                this.$router.push(Core.Definition.getDefinition('/formulaire/entrees/nouvelle-entree/' + row.id))
            },
            clickEdit(value, cell, row) {
                this.$router.push('/formulaire/entrees/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
